// const NodeRSA = require('./NodeRSA');
const NodeRSA = require('node-rsa')
	;

// rsa 加密
let RSA = function(str, key){
		let buffer = new Buffer( str )
			, pubKey = new NodeRSA(key, 'pkcs8-public')
			;

		// java 默认 pkcs1 秘钥
		pubKey.setOptions({
			encryptionScheme: 'pkcs1'
		});

		return pubKey.encrypt(buffer, 'base64');
	}
	;

export {
	RSA
};